import { collections } from "@/mocks/home";

const toneMap: Record<string, string> = {
  primary: "text-primary-300",
  accent: "text-accent-400",
  secondary: "text-background-300",
};

export default function CollectionIndex() {
  return (
    <section id="collections" className="bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="reveal grid grid-cols-1 gap-8 border-b border-background-100/20 pb-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="font-label text-[11px] tracking-[0.3em] text-accent-400">
              INDEX · 合集索引
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight md:text-[44px]">
              按编号查阅
              <br />
              站内全部合集
            </h2>
          </div>
          <p className="text-sm leading-8 text-background-200/80 lg:col-span-5">
            索引区是本站最醒目的部分。每个合集独立编号，收录条目与期数一目了然，
            配合黑料总站镜像与备用通道使用，查找速度更快。
          </p>
        </div>

        <div className="mt-4">
          {collections.map((item) => (
            <a
              key={item.id}
              href="#collections"
              className="reveal group flex flex-col gap-4 border-b border-background-100/10 py-7 transition-colors hover:bg-background-100/5 md:flex-row md:items-center md:gap-8 md:px-4"
            >
              <span
                className={`font-heading text-3xl font-black tabular-nums md:text-[40px] ${
                  toneMap[item.tone] ?? "text-background-300"
                }`}
              >
                {item.no}
              </span>
              <div className="flex-1">
                <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                  {item.name}
                </h3>
                <p className="mt-2 max-w-3xl text-sm leading-7 text-background-200/75">
                  {item.desc}
                </p>
              </div>
              <span className="font-label text-sm tracking-wider text-background-300">
                {item.count}
              </span>
              <i className="ri-arrow-right-line text-xl text-background-300 transition-transform group-hover:translate-x-1 group-hover:text-accent-400" />
            </a>
          ))}
        </div>

        <div className="reveal mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs tracking-wider text-background-300">
            索引每周整理一次 · 最近整理 2026.09.11
          </p>
          <a
            href="#channels"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 font-label text-sm text-foreground-950 transition-colors hover:bg-accent-400"
          >
            前往入口通道
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}